import React, { useEffect } from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { useSettingsStore } from '../stores/settingsStore';
import { useAuth } from '../hooks/useAuth';

interface MaintenanceWrapperProps {
  children: React.ReactNode;
}

const MaintenanceWrapper: React.FC<MaintenanceWrapperProps> = ({ children }) => {
  const { maintenanceMode } = useSettingsStore();
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  // Bakım modu aktifken ve giriş yapılmamışken sadece /bakim ve /yonetim/* sayfalarına izin ver
  if (maintenanceMode && !isAuthenticated) {
    if (location.pathname === '/bakim' || location.pathname.startsWith('/yonetim')) {
      return <>{children}</>;
    }
    return <Navigate to="/bakim" replace />;
  }

  return <>{children}</>;
};

export default MaintenanceWrapper;
